module.exports = __webpack_public_path__ + "img/logo_bola_preto.61d1ff01.jpg";